import { motion } from "framer-motion";

/**
 * PageHeader — consistent title + subtitle + optional actions row.
 * data-testid: page-header
 */
export default function PageHeader({ eyebrow, title, subtitle, actions, testId = "page-header" }) {
  return (
    <motion.header
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      className="mb-8 flex flex-col md:flex-row md:items-end md:justify-between gap-4"
      data-testid={testId}
    >
      <div className="min-w-0">
        {eyebrow && (
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-muted-foreground mb-2">
            {eyebrow}
          </div>
        )}
        <h1 className="font-display font-black text-3xl md:text-4xl tracking-tight text-foreground">
          {title}
        </h1>
        {subtitle && (
          <p className="text-sm md:text-base text-muted-foreground mt-2 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </motion.header>
  );
}
